export default "__VITE_ASSET__ZYnK3A98__"